import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import IndividualImage from "../../../assets/images/registrationtype/individual.svg";
import CenterImage from "../../../assets/images/registrationtype/center.svg";

import { translationConstants, viewPathConstants } from "../../../constants";
import RegistrationCard from "./RegistrationCard";

const BaseChooseRegistrationView = ({
  setShowRegistraionModal,
  setShowCenterRegistraionModal,
  setShowChooseRegistrationModal,
  toggleShowChoose,
  setShow,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedRegistration, setSelectedRegistration] = useState(0);

  const handleContinueClick = () => {
    setShowChooseRegistrationModal?.(false);
    if (selectedRegistration === 0) {
      setShowRegistraionModal?.(true);
      toggleShowChoose?.();
      setShow?.();
      setShowCenterRegistraionModal?.(false);
    } else {
      setShowCenterRegistraionModal
        ? setShowCenterRegistraionModal(true)
        : navigate(viewPathConstants.CENTER_REGISTRATION);
      setShowRegistraionModal?.(false);
    }
  };

  return (
    <>
      <span className="welcomeSaudiPara text-center">
        {t(translationConstants.welcomePara)}
      </span>
      <span className="createAccountPara text-center">
        {t(translationConstants.createAccount)}
      </span>
      <div className="d-flex pt-3 cursor-pointer">
        <RegistrationCard
          image={IndividualImage}
          label={t(translationConstants.INDIVIDUAL)}
          isSelected={selectedRegistration === 0}
          onClick={() => setSelectedRegistration(0)}
        />
        <div className="vertical-line"></div>
        <RegistrationCard
          image={CenterImage}
          label={t(translationConstants.CENTER)}
          isSelected={selectedRegistration === 1}
          onClick={() => setSelectedRegistration(1)}
        />
      </div>
      <Button className="Registeration-button" onClick={handleContinueClick}>
        {t(translationConstants.continue)}
      </Button>
    </>
  );
};

export default BaseChooseRegistrationView;
